module.exports = __webpack_public_path__ + "img/zheng.8531fa46.png";